import { memo, useCallback, useMemo, useState } from 'react'
import { allowCookies, hasConsent } from 'app/cookiesEvents'
import BG from 'components/core/BG/BG'
import Button from 'components/core/Button/Button'
import useDelayedActiveState from 'lib/react/hooks/useDelayedActiveState'
import classNames from 'lib/util/classNames'
import { useModalContext } from '../Modal/provider/ModalProvider'
import styles from './CookieConsent.module.scss'

/**
 * The `CookieConsent`
 *
 * @returns {React.ReactElement} the element
 */
function CookieConsent () {
  const { showModal } = useModalContext()
  const [isDismissed, setIsDismissed] = useState(false)
  const isShown = useMemo(() => !hasConsent && !isDismissed, [isDismissed])
  const isRender = useDelayedActiveState(isShown, 0, 0.7)
  const isVisible = useDelayedActiveState(isShown, 0.1, 0)
  const classNameOutput = useMemo(
    () => classNames([styles.container, isVisible && styles.active]),
    [isVisible]
  )

  /**
   * Handle click to open modal for privacy and terms
   */
  const handleClickPrivacyTerms = useCallback(e => {
    showModal({
      id: 'app:privacy_terms'
    })
  }, [])

  /**
   * Handle click to reject
   */
  const handleClickReject = useCallback(() => {
    setIsDismissed(true)
  }, [])

  /**
   * Handle click to accept
   */
  const handleClickAccept = useCallback(() => {
    allowCookies()
    setIsDismissed(true)
  }, [])

  if (!isRender) {
    return null
  }

  return (
    <div className={classNameOutput} role="alertdialog">
      <div className={styles.box}>
        <div className={styles.content}>
          <BG className={styles.bg} color="i" opacity="e" mask="none" />
          <div className={styles.display}>
            <h1>Allow Cookies?</h1>
            <p>
              To provide you with the <strong>best experience</strong>, this
              site uses cookies. For more information, please refer to our{' '}
              <a onClick={handleClickPrivacyTerms}>
                Terms & Conditions and Privacy Policy.
              </a>
            </p>
            <div className={styles.options}>
              <Button
                size="medium"
                color="c"
                onClick={handleClickReject}
                icon="close"
              >
                Reject
              </Button>
              <Button size="medium" onClick={handleClickAccept} icon="check">
                Accept
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(CookieConsent)
